module.exports = __webpack_public_path__ + "img/1_1-industriale-fabbrica-1.b33ae430.png";